module.exports = __webpack_public_path__ + "img/service_electronics.d3ada569.png";